// A sheet that exists on only one side names itself rather than carrying a dot.
export const SHEET_STATE: Record<string, string | undefined> = {
  added: "new",
  removed: "dropped",
};
